import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { useGetTreatmentProgramsQuery } from '~/store/services/enumerations';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassTreatmentProgramsField = ({
  value,
  onChange,
  leftIcon,
  isReadOnly = false,
  placeholder,
}: GroupClassBaseFieldProps<string[]>) => {
  const { data: treatmentProgramsData } = useGetTreatmentProgramsQuery();
  const readOnlyProps = isReadOnly ? { inputValue: value?.join(', ') } : {};
  const treatmentProgramOptions = useMemo(
    () =>
      treatmentProgramsData?.map((program) => ({
        label: program.label,
        value: program.code,
      })),
    [treatmentProgramsData],
  );
  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__programs`}
      label="Programs"
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__programs-select`}
        isSingleSelect={false}
        onChange={(options) => {
          const selectedValues = Array.isArray(options)
            ? options.map((opt) => opt.value)
            : [];

          onChange(selectedValues);
        }}
        leftIcon={leftIcon}
        isReadOnly={isReadOnly}
        placeholder={placeholder}
        options={treatmentProgramOptions}
        value={treatmentProgramOptions?.filter((option) =>
          value?.includes(option.value),
        )}
        withCheckBox
        {...readOnlyProps}
      />
    </InputGroupV2>
  );
};
